// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const DragonSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'dragon-attack',
    metadata: {
      frames: {
        'dragon-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-attack-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-attack-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-attack-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragon/attack.png',
        size: {
          w: 1024,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'dragon-attack': [
          'dragon-attack-0',
          'dragon-attack-1',
          'dragon-attack-2',
          'dragon-attack-3',
        ],
      },
    },
  },
  {
    name: 'dragon-die',
    metadata: {
      frames: {
        'dragon-die-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-die-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-die-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-die-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-die-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragon/die.png',
        size: {
          w: 1280,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'dragon-die': [
          'dragon-die-0',
          'dragon-die-1',
          'dragon-die-2',
          'dragon-die-3',
          'dragon-die-4',
        ],
      },
    },
  },
  {
    name: 'dragon-fireAttack',
    metadata: {
      frames: {
        'dragon-fireAttack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dragon-fireAttack-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dragon-fireAttack-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dragon-fireAttack-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dragon-fireAttack-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dragon-fireAttack-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragon/fireAttack.png',
        size: {
          w: 768,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dragon-fireAttack': [
          'dragon-fireAttack-0',
          'dragon-fireAttack-1',
          'dragon-fireAttack-2',
          'dragon-fireAttack-3',
          'dragon-fireAttack-4',
          'dragon-fireAttack-5',
        ],
      },
    },
  },
  {
    name: 'dragon-exhaust',
    metadata: {
      frames: {
        'dragon-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-exhaust-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragon/exhaust.png',
        size: {
          w: 512,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'dragon-exhaust': ['dragon-exhaust-0', 'dragon-exhaust-1'],
      },
    },
  },
  {
    name: 'dragon-idle',
    metadata: {
      frames: {
        'dragon-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-idle-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-idle-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragon/idle.png',
        size: {
          w: 768,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'dragon-idle': ['dragon-idle-0', 'dragon-idle-1', 'dragon-idle-2'],
      },
    },
  },
  {
    name: 'dragon-run',
    metadata: {
      frames: {
        'dragon-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-run-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-run-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-run-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'dragon-run-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dragon/run.png',
        size: {
          w: 1280,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'dragon-run': [
          'dragon-run-0',
          'dragon-run-1',
          'dragon-run-2',
          'dragon-run-3',
          'dragon-run-4',
        ],
      },
    },
  },
];
